import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../navbar/Navbar";
import LinkToRegistration from "../../property/component/LinkToRegistration";
import Stepper from "../../Stepper/component/Stepper";
import { selectPdEId } from "../../property/propertySlice";
import { fetchPDEInfoAsync, selectPDEInfo } from "../../user/userSlice";

import { format, parseISO, isFuture } from "date-fns";
import {
  fetchtimeslab,
  timeSlabOptions as selectTimeSlabOptions,
  fetchSROAppointmnet,
  //selectSROAppointments,
  fetchBookSROAppointment,
  //resetTimeSlab,
  selectbookappointment,
} from "../OnlineAppointmentSlice";
import axios from "axios";
import { completeStep } from "../../Stepper/stepperSlice";
import API_BASE_URL, { Google_url, Webex_url } from "../../BaseURL/baseURL";
import TypewriterAnimation from "../../Loader/TypewriterAnimation";
import { toast } from "react-toastify";
import { previewDeed } from "../../uploadDocument/UploadDocumentSlice";

const OnlineAppointment = () => {
  const [AppointmentDate, setAppointmentDate] = useState(new Date());
  // const [ResAppointmentDate, setResAppointmentDate] = useState("");
  const [timeslab, setTimeslab] = useState("");
  const [Selecttimeslab, setSelecttimeslab] = useState("");
  const [Selectedtime, setSelectedtime] = useState("");
  const [SelecttimeSlabOptions1, setSelecttimeSlabOptions1] = useState([]);
  const [appointmentSROs, setappointmentSROs] = useState("");
  const [appointmentSROsOptions, setappointmentSROsOptions] = useState([]);
  const [selectedAppointmentSRO, setSelectedAppointmentSRO] = useState("");
  const [selectedSRO, setSelectedSRO] = useState("");
  ////;
  const [ModifyAppointmentDetails, setModifyAppointmentDetails] = useState("");
  const [flag, setFlag] = useState(null);
  const [error, setError] = useState(null);
  const [meetingLink, setMeetingLink] = useState(null);
  const currentStep = useSelector((state) => state.stepper.currentStep);
  const [isLoading, setIsLoading] = useState(false);

  // const timeSlabOptions = useSelector(selectTimeSlabOptions);
  // const sroAppointments = useSelector(selectSROAppointments);
  const bookappointment = useSelector(selectbookappointment);
  const state = useSelector((state) => state.OnlineAppointment || {}); // Fallback to an empty object

  const today = new Date().toISOString().split("T")[0];

  const { mode, pdeid, appointmentDetails, status } = state;
  // Check if booking_Date exists before formatting
  const formattedDate = bookappointment.booking_Date
    ? format(new Date(bookappointment.booking_Date), "dd-MMM-yyyy")
    : "";

  const dispatch = useDispatch();
  const storePde = useSelector(selectPdEId);
  const pde = storePde ? storePde : pdeid;
  const pdeInfo = useSelector(selectPDEInfo);
  // const pdeData = pdeInfo?.pdeData[0];
  const partyDetails = pdeInfo?.partyDetails[0];
  const [emails, setEmails] = useState("");

  const appointmentType = useSelector(
    (state) => state.Procedure.appointmentType
  );

  console.log(pde);

  const PreviewDeed = () => {
    debugger;
    setIsLoading(true);
    dispatch(previewDeed(pde))
      .unwrap()
      .then((base64) => {
        const bytes = atob(base64);
        const arr = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
        const blob = new Blob([arr], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob), "_blank");
      })
      .catch((err) => alert(`Preview failed: ${err}`))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (pdeInfo) {
      const firstPartyEmails =
        partyDetails?.savefirstparty?.map((entry) => entry.email) || [];
      const secondPartyEmails =
        partyDetails?.savesecondparty?.map((entry) => entry.email) || [];
      const witnessEmails =
        partyDetails?.savewitness?.map((entry) => entry.email) || [];

      const allEmails = [
        ...firstPartyEmails,
        ...secondPartyEmails,
        ...witnessEmails,
      ];
      const emailsString = allEmails.join(", ");

      setEmails(emailsString);
    }
  }, [pdeInfo]);

  useEffect(() => {
    ////;
    if (mode === "modify" && pdeid) {
      // Fetch existing appointment data if modifying
      axios
        .get(
          `${API_BASE_URL}/OnlineAppointment/GetAppointmentDetails?PDEid=${pdeid}`
        )
        .then((response) => {
          if (response.data) {
            ////;
            setModifyAppointmentDetails(response.data);
            // Handle the response data as needed
            var modresp = response.data.flag;
          } else {
            setError("Invalid response data");
          }
        })
        .catch((error) => {
          setError("An error occurred while fetching the appointment details");
        });
    }
  }, [mode, pdeid]);

  useEffect(() => {
    if (Array.isArray(bookappointment) && bookappointment.length === 0) {
      if (pde) {
        ////;

        axios
          .get(
            `${API_BASE_URL}/OnlineAppointment/CHECK_pdeid_status?PDEid=${pde}`
          )
          .then((response) => {
            ////;
            if (response.data.flag) {
              setFlag(response.data.flag);
              if (mode === "modify" && ModifyAppointmentDetails === "Y") {
                setFlag("Y");
                fetchtimeslab();
              }

              if (response.data.flag === "Y") {
                fetchtimeslab();
              }
            } else {
              setError("Invalid flag response");
            }
          })
          .catch((error) => {
            setError("An error occurred while fetching the flag");
          });
      }
    }
  }, [pde, bookappointment, ModifyAppointmentDetails]);

  const handletimeslabChange = (e) => {
    const selectedvalue = e.target.value;
    setSelecttimeslab(selectedvalue);
    const selectedOption = SelecttimeSlabOptions1.find(
      (option) => option.time_slab_id === selectedvalue
    );

    // If a valid option is found, update the selectedTime state
    if (selectedOption) {
      ////;
      setSelectedtime(selectedOption.time_slab);
    }
    fetchappointmentSRO(selectedvalue);
  };

  const fetchtimeslab = async () => {
    try {
      ////;
      const response = await fetch(
        `${API_BASE_URL}/OnlineAppointment/Appointment_Select_Time_Slab?PDEid=${pde}`
        // "https://localhost:7122/api/PropertyRegistration/get_registration_fee?deedcode=01&subdeedcode=01"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      ////;
      const data = await response.json();
      setSelecttimeSlabOptions1(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  };

  const fetchappointmentSRO = async (time) => {
    try {
      const date = AppointmentDate.toISOString().split("T")[0];
      if (mode === "modify") {
        const response = await fetch(
          // `https://localhost:7122/api/OnlineAppointment/Appointment_Select_Time_Slab_Appointment?PDEid=${pde}&Appointmentdate=${date}&timeslab=${time}&appointment_type=N`
          `${API_BASE_URL}/OnlineAppointment/Appointment_Select_Time_Slab_Appointment_modify?PDEid=${pde}&Appointmentdate=${date}&timeslab=${time}&appointment_type=N`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        ////;
        const data = await response.json();
        ////;
        setappointmentSROsOptions(data);
      } else {
        const response = await fetch(
          // `https://localhost:7122/api/OnlineAppointment/Appointment_Select_Time_Slab_Appointment?PDEid=${pde}&Appointmentdate=${date}&timeslab=${time}&appointment_type=N`
          `${API_BASE_URL}/OnlineAppointment/Appointment_Select_Time_Slab_Appointment?PDEid=${pde}&Appointmentdate=${date}&timeslab=${time}&appointment_type=N`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        ////;
        const data = await response.json();
        setappointmentSROsOptions(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  };

  const parseTimeSlab = (timeSlab) => {
    const [start, end] = timeSlab.split(" to ");
    return { start, end };
  };

  const createWebexRequest = (meetingDetails) => {
    return {
      adhoc: false,
      enabledAutoRecordMeeting: true,
      allowAnyUserToBeCoHost: false,
      enabledJoinBeforeHost: false,
      enableConnectAudioBeforeHost: false,
      excludePassword: false,
      publicMeeting: false,
      enabledWebcastView: false,
      enableAutomaticLock: false,
      allowFirstUserToBeCoHost: false,
      allowAuthenticatedDevices: false,
      sendEmail: true,
      enabledAudioWatermark: false,
      enabledVisualWatermark: false,
      requireAttendeeLogin: false,
      restrictToInvitees: false,
      title: meetingDetails.title,
      start: meetingDetails.startDateTime,
      end: meetingDetails.endDateTime,
      timezone: meetingDetails.timeZone,
      invitees: meetingDetails.attendees.map((email) => ({ email })),
      hostEmail: meetingDetails.hostEmail,
    };
  };

  const convertTo24HourFormat = (time) => {
    const [timePart, period] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (period === "p.m" && hours < 12) {
      hours += 12;
    } else if (period === "a.m" && hours === 12) {
      hours = 0;
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  const formatDateToISO = (date) => format(new Date(date), "yyyy-MM-dd");

  // const handleBookNow = async (srocode) => {
  //   setIsLoading(true);
  //   setError(null);

  //   try {
  //     ;

  //     const selectedTimeSlab = SelecttimeSlabOptions1.find(
  //       (slab) => slab.time_slab_id === Number(Selecttimeslab)
  //     )?.time_slab;

  //     if (!selectedTimeSlab || selectedTimeSlab === "Select Time Slab") {
  //       console.error("Invalid time slab selected.");
  //       toast.error("Please select a valid time slab.");
  //       return;
  //     }

  //     const { start: startTime, end: endTime } =
  //       parseTimeSlab(selectedTimeSlab);
  //     const formattedAppointmentDate = formatDateToISO(AppointmentDate);

  //     const startDateTimeString = `${formattedAppointmentDate}T${convertTo24HourFormat(
  //       startTime
  //     )}:00+05:30`;
  //     const endDateTimeString = `${formattedAppointmentDate}T${convertTo24HourFormat(
  //       endTime
  //     )}:00+05:30`;

  //     const startDateTime = new Date(startDateTimeString);
  //     const endDateTime = new Date(endDateTimeString);

  //     if (!isFuture(startDateTime)) {
  //       console.error("Selected times must be in the future.");
  //       setError("Please select a time slot in the future.");
  //       toast.error("Selected times must be in the future.");
  //       return;
  //     }

  //     console.log("Start DateTime:", startDateTime);
  //     console.log("End DateTime:", endDateTime);

  //     // For Virtual Appointments
  //     if (appointmentType === "V") {
  //       const meetingDetails = {
  //         title: pde,
  //         startDateTime: startDateTimeString,
  //         endDateTime: endDateTimeString,
  //         timeZone: "Asia/Kolkata",
  //         attendees: emails.split(", "),
  //         // hostEmail: "dehradunddn282@gmail.com",
  //         // hostEmail: "services@doonbusinessmachine.com",
  //         hostEmail: "dehradunddn04@gmail.com",
  //       };

  //       try {
  //         const webexRequest = createWebexRequest(meetingDetails);
  //         const webexResponse = await axios.post(
  //           `${Webex_url}/Webex/create-meeting`,
  //           webexRequest
  //         );

  //         const link = webexResponse.data.webLink;
  //         setMeetingLink(link);

  //         if (!link) {
  //           throw new Error("Webex link generation failed.");
  //         }

  //         console.log("Webex meeting link:", link);

  //         const payload = {
  //           PDE_ID: pde,
  //           appointment_date: new Date(AppointmentDate)
  //             .toISOString()
  //             .split("T")[0],
  //           timeslabID: Selecttimeslab,
  //           srocode: srocode,
  //           appointment_type: appointmentType,
  //           meeting_link: link,
  //           mode: mode,
  //         };

  //         const response = await dispatch(
  //           fetchBookSROAppointment(payload)
  //         ).unwrap();
  //         console.log("Appointment booked successfully:", response);
  //         toast.success("Appointment Booked Successfully!");
  //         dispatch(completeStep({ step: currentStep }));
  //       } catch (webexError) {
  //         console.error("Webex error:", webexError);
  //         toast.error("Failed to create Webex meeting. Please try again.");
  //       }
  //     } else {
  //       // For Physical Appointments
  //       const payload = {
  //         PDE_ID: pde,
  //         appointment_date: new Date(AppointmentDate)
  //           .toISOString()
  //           .split("T")[0],
  //         timeslabID: Selecttimeslab,
  //         srocode: srocode,
  //         appointment_type: appointmentType,
  //         meeting_link: "",
  //         mode: mode,
  //       };

  //       const response = await dispatch(
  //         fetchBookSROAppointment(payload)
  //       ).unwrap();
  //       console.log("Appointment booked successfully:", response);
  //       toast.success("Appointment Booked Successfully!");
  //       dispatch(completeStep({ step: currentStep }));
  //     }
  //   } catch (error) {
  //     console.error("Error booking appointment:", error);
  //     toast.error("Failed to book appointment. Please try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleBookNow = async (srocode) => {
    setIsLoading(true);
    setError(null);

    try {
      // 1) Check lat/long status first
      const statusRes = await axios.get(
        `${API_BASE_URL}/OnlineAppointment/GetLatLongStatus?pdeId=${pde}`
      );
      const { statusCode } = statusRes.data;

      // if (statusCode === "400") {
      //   // if no lat/long submitted, bail out immediately
      //   toast.error("Please Submit Latitude and Longitude first");
      //   return;
      // }
      if (statusCode !== "200") {
        // handle other unexpected codes if you need
        toast.error("Please Submit Latitude and Longitude first");
        return;
      }

      // 2) only if statusCode==='200' do we go on:
      // — validate time slab
      const selectedTimeSlab = SelecttimeSlabOptions1.find(
        (slab) => slab.time_slab_id === Number(Selecttimeslab)
      )?.time_slab;

      if (!selectedTimeSlab || selectedTimeSlab === "Select Time Slab") {
        toast.error("Please select a valid time slab.");
        return;
      }

      // — parse times, format dates
      const { start: startTime, end: endTime } =
        parseTimeSlab(selectedTimeSlab);
      const formattedAppointmentDate = formatDateToISO(AppointmentDate);

      const startDateTimeString = `${formattedAppointmentDate}T${convertTo24HourFormat(
        startTime
      )}:00+05:30`;
      const endDateTimeString = `${formattedAppointmentDate}T${convertTo24HourFormat(
        endTime
      )}:00+05:30`;

      const startDateTime = new Date(startDateTimeString);
      const endDateTime = new Date(endDateTimeString);

      if (!isFuture(startDateTime)) {
        toast.error("Selected times must be in the future.");
        return;
      }

      // 3) booking logic
      if (appointmentType === "V") {
        // Virtual: create Webex then book
        try {
          const meetingDetails = {
            title: pde,
            startDateTime: startDateTimeString,
            endDateTime: endDateTimeString,
            timeZone: "Asia/Kolkata",
            attendees: emails.split(", "),
            hostEmail: "dehradunddn04@gmail.com",
          };
          const webexRequest = createWebexRequest(meetingDetails);
          const webexResponse = await axios.post(
            `${Webex_url}/Webex/create-meeting`,
            webexRequest
          );
          const link = webexResponse.data.webLink;
          if (!link) throw new Error("Webex link failed");
          setMeetingLink(link);

          const payload = {
            PDE_ID: pde,
            appointment_date: formattedAppointmentDate,
            timeslabID: Selecttimeslab,
            srocode,
            appointment_type: appointmentType,
            meeting_link: link,
            mode,
          };
          await dispatch(fetchBookSROAppointment(payload)).unwrap();
          toast.success("Appointment Booked Successfully!");
          dispatch(completeStep({ step: currentStep }));
        } catch (webexError) {
          console.error(webexError);
          toast.error("Failed to create Webex meeting. Please try again.");
        }
      } else {
        // Physical
        const payload = {
          PDE_ID: pde,
          appointment_date: formattedAppointmentDate,
          timeslabID: Selecttimeslab,
          srocode,
          appointment_type: appointmentType,
          meeting_link: "",
          mode,
        };
        await dispatch(fetchBookSROAppointment(payload)).unwrap();
        PreviewDeed();
        toast.success("Appointment Booked Successfully!");
        dispatch(completeStep({ step: currentStep }));
      }
    } catch (error) {
      console.error("Error booking appointment:", error);
      toast.error("Failed to book appointment. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <LinkToRegistration />
      {/* <div className="flex min-h-screen"> */}
      <div className="flex flex-grow">
        <div className="w-1/5 bg-white flex justify-center">
          <Stepper />
        </div>
        <div className="w-0.5 border-none bg-neutral-400"></div>
        <div className="w-4/5 flex justify-center">
          <div className="w-full   py-6 bg-gray-50 rounded-lg">
            <div className="space-y-4 ">
              {isLoading && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                  <div className="absolute inset-0 bg-gray-500 opacity-50 backdrop-blur-sm"></div>

                  <TypewriterAnimation />
                </div>
              )}
              <div className="container text-center">
                <div className="grid grid-flow-row justify-center">
                  <h4> PDE ID : {pde}</h4>
                  <p className="text-red-400 uppercase">
                    <small>
                      The User is advised to print the PDE report exclusively
                      following a scheduled appointment
                    </small>
                  </p>
                  <p className="text-red-700 uppercase semi-bold">
                    <small>
                      The User is advised to take Latitude and Longitude through
                      mobile app before taking appointment
                    </small>
                  </p>
                  {flag === "N" &&
                    (bookappointment?.result !== 1 ||
                      bookappointment?.result !== 2 ||
                      bookappointment?.result !== 0 ||
                      bookappointment?.result !== 4) && (
                      <>
                        <p className="text-blue-700 mt-3">
                          <b>
                            {" "}
                            Please Fill Previous details before Taking
                            Appointment
                          </b>
                        </p>
                      </>
                    )}
                  {flag !== "N" && (
                    <>
                      {bookappointment.result === 1 && (
                        <>
                          <p className="text-blue-700 mt-3">
                            <b>
                              PDE Submitted Successfully, with selected time
                              booking. Please Take the Print out
                            </b>
                          </p>
                        </>
                      )}
                      {bookappointment.result === 2 && (
                        <>
                          <p className="text-blue-700 mt-3">
                            <b>
                              PDE Failed to submitted as no appointment left on
                              selected time slab .
                            </b>
                          </p>
                        </>
                      )}
                      {bookappointment.result === 0 && (
                        <>
                          <p className="text-blue-700 mt-3">
                            <b> Appointment for Pde : {pde} Booked</b>
                          </p>
                        </>
                      )}
                      {bookappointment.result === 4 && (
                        <>
                          <p className="text-blue-700 mt-3">
                            <b> PDE Failed To Save due to Technical Issues.</b>
                          </p>
                        </>
                      )}
                    </>
                  )}
                  {flag !== "N" && (
                    <>
                      <div className="grid-flow-row mt-3">
                        <div className="grid grid-cols-2 mt-3">
                          <label className="block w-full relative">
                            Appointment Date
                          </label>
                          <div className="block w-full relative">
                            {Array.isArray(bookappointment) &&
                              bookappointment.length === 0 && (
                                <>
                                  <input
                                    type="date"
                                    value={
                                      AppointmentDate
                                        ? AppointmentDate.toISOString().split(
                                            "T"
                                          )[0]
                                        : ""
                                    }
                                    onChange={(e) =>
                                      setAppointmentDate(
                                        new Date(e.target.value)
                                      )
                                    }
                                    id="date"
                                    min={today}
                                    className="block w-full pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    required
                                  />

                                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                                </>
                              )}
                            {(bookappointment?.result === 1 ||
                              bookappointment?.result === 0) && (
                              <span className="text-decoration-none bg-transparent border-none text-blue-900 fw-semibold">
                                {formattedDate}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="grid grid-cols-2 mt-3">
                          <p>Select Time Slab</p>
                          <div className="block w-full relative">
                            {Array.isArray(bookappointment) &&
                              bookappointment.length === 0 && (
                                <>
                                  <select
                                    value={Selecttimeslab}
                                    onChange={handletimeslabChange}
                                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                    required
                                  >
                                    {SelecttimeSlabOptions1.map((option) => (
                                      <option
                                        key={option.time_slab_id}
                                        value={option.time_slab_id}
                                      >
                                        {option.time_slab}
                                      </option>
                                    ))}
                                  </select>
                                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                                </>
                              )}
                            {(bookappointment?.result === 1 ||
                              bookappointment?.result === 0) && (
                              <span className="text-decoration-none bg-transparent border-none text-blue-900 fw-semibold">
                                {bookappointment.time_Slab}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="grid grid-cols-2 mt-3">
                          <p>Appointment Office</p>
                          <div className="block w-full relative">
                            {Array.isArray(bookappointment) &&
                              bookappointment.length === 0 && (
                                <>
                                  {appointmentSROsOptions.map(
                                    (option, index) => (
                                      <button
                                        key={index}
                                        onClick={() => {
                                          setSelectedAppointmentSRO(
                                            option.srocode
                                          );
                                          handleBookNow(option.srocode);
                                        }}
                                        className="px-8 py-1 bg-blue-500 text-white rounded-full text-md"
                                      >
                                        {option.sroname_eng}
                                      </button>
                                    )
                                  )}
                                </>
                              )}
                            {/* <div className="flex justify-end mb-4">
                              <button
                                onClick={PreviewDeed}
                                className="px-4 py-2 bg-gray-100 text-blue-600 rounded hover:bg-gray-200 disabled:opacity-50"
                              >
                                Preview Deed
                              </button>
                            </div> */}
                            {(bookappointment?.result === 1 ||
                              bookappointment?.result === 0) && (
                              <span className="text-decoration-none bg-transparent border-none text-blue-900 fw-semibold">
                                {bookappointment.sroname_eng}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnlineAppointment;
